import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { H2 } from '@components/styles/Typography';
import { ArrowLeftIcon } from '@components/icons';

const ContractPageLayout = ({ title, children }) => {
    const router = useRouter();

    const handleGoBack = () => {
        router.back();
    };
    return (
        <ContractContainer>
            <Header>
                <BackIcon onClick={handleGoBack} data-testid="back-button">
                    <ArrowLeftIcon />
                </BackIcon>
                <H2>{title}</H2>
            </Header>
            {children}
        </ContractContainer>
    );
};
const Header = styled.div`
    position: fixed;
    background-color: ${({ theme }) => theme.colors.secondary};
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    width: 100vw;

    h2 {
        max-width: 300px;
    }

    @media (min-width: 1024px) {
        display: none;
    }
`;
const BackIcon = styled.div`
    cursor: pointer;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
`;
const ContractContainer = styled.div`
    display: grid;
    width: 100%;
    overflow: hidden;
    grid-template-columns: 12.08vw 2fr;
    gap: 5.27vw;
    margin-top: 130px;
    padding: 0 4.16vw 50px 2.77vw;

    h2 {
        text-align: center;
    }

    table {
        table-layout: fixed;
        td {
            word-break: break-word;
        }
    }

    @media (max-width: 1024px) {
        margin-top: 30px;
        grid-template-columns: 1fr;
        gap: 0;
        padding: 0;
    }
`;

export default ContractPageLayout;
